import  request  from '../../Interceptor/request.js'

//获取全部信息
export function waterAll(data) {
    return request({
        url: '/paymentInfo/list',
        method: 'get',
        params:data
    })
}

//获取余额
export function balances(data) {
    return request({
        url: '/eleBill/getBalance?devId='+data,
        method: 'get'
    })
}

//汉阳获取余额
export function hybalance(data) {
    return request({
        url: '/devCmd/readSurplus',
        method: 'get',
        params:data
    })
}


//请求支付流程接口
export function orderAll(data){
    return request({
        url: '/order',
        method: 'post',
        data:data
    })
}

export function wxPa(data){
    return request({
        url: '/pay/wxPay/mp-pay',
        method: 'get',
        params:data
    })
}

export function orderList(data){
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}
